// Analyst tier: closed set held by pangaea (REG-04). SAM's own value is only
// ever SMALL or OTHER_THAN_SMALL and is never written from a form.
export const businessSizeOptions = [
    {
        value: 'SMALL',
        label: 'Small business'
    },
    {
        value: 'MID_SIZE',
        label: 'Mid-size'
    },
    {
        value: 'LARGE',
        label: 'Large business'
    },
    {
        value: 'OTHER_THAN_SMALL',
        label: 'Other than small'
    },
    {
        value: 'UNKNOWN',
        label: 'Unknown'
    }
];
export function companySizeLabel(value) {
    return businessSizeOptions.find((o)=>o.value === value)?.label ?? 'Unknown';
}
const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
/** "SAM: Small business · NAICS 541512 · 2 Nov 2026", or '' when SAM has no value. */ export function samSizeNote(samSize, naics, retrievedAt) {
    if (!samSize) return '';
    const parts = [
        `SAM: ${companySizeLabel(samSize)}`
    ];
    if (naics) parts.push(`NAICS ${naics}`);
    if (retrievedAt) {
        const d = retrievedAt.toDate();
        parts.push(`${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`);
    }
    return parts.join(' · ');
}
